import React from 'react';

// Report-entry first step: pick which flagged findings this message asks about.
export function IssuesSelect({ issues, checked, setChecked, onNext }) {
  const toggle = (i) =>
    setChecked(checked.includes(i) ? checked.filter((x) => x !== i) : [...checked, i]);
  return (
    <div>
      <h2 className="mb-1 text-lg font-semibold text-slate-900 dark:text-white">
        Which items do you want to ask about?
      </h2>
      <p className="mb-4 text-sm text-slate-600 dark:text-slate-300">
        Each selected item becomes its own numbered question in one message.
      </p>
      <div className="space-y-2">
        {issues.map((issue, i) => (
          <label key={i}
            className={`flex cursor-pointer items-start gap-3 rounded-xl border p-3 transition ${
              checked.includes(i)
                ? 'border-emerald-500 bg-emerald-50 dark:bg-emerald-900/30'
                : 'border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-800'
            }`}>
            <input type="checkbox" className="mt-1" checked={checked.includes(i)}
              onChange={() => toggle(i)} />
            <span>
              <span className="block text-sm font-semibold text-slate-900 dark:text-white">{issue.title}</span>
              {issue.section_ref && (
                <span className="block text-xs text-slate-500 dark:text-slate-400">Found in: {issue.section_ref}</span>
              )}
            </span>
          </label>
        ))}
      </div>
      <div className="mt-6 flex justify-end">
        <button type="button" disabled={checked.length === 0} onClick={onNext}
          className="rounded-lg bg-emerald-600 px-5 py-2 text-sm font-semibold text-white hover:bg-emerald-700 disabled:opacity-50">
          Next ({checked.length} selected)
        </button>
      </div>
    </div>
  );
}
